import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CiUser } from "react-icons/ci";

const AccountTypeSelection = () => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState(null);

  const handleSelect = (type) => {
  setSelectedType(type);
  localStorage.setItem("accountType", type);
  setTimeout(() => {
    navigate("/register");
  }, 1000);
};


  return (
    <div className="min-h-screen flex flex-col space-y-5 bg-[#130828] p-4">
      {/* Progress bar */}
      <div className="w-full max-w-md h-2 bg-gray-200 mt-10 rounded mb-6">
        <div className="h-full w-1/3 bg-[#BE3593] rounded" />
      </div>

      {/* Title */}
      <h2 className="text-2xl font-bold text-center mb-2 bg-gradient-to-r from-[#BE3593] via-[#B7D080] to-[#B7D080] text-transparent bg-clip-text">
        What type of <span className="font-extrabold">account</span> do you want to <span className="font-extrabold">create</span>?
      </h2>
      <p className="text-white mb-6">Please select an option to continue</p>

      {/* Options */}
      <div className="flex flex-col gap-4 text-lg space-y-5 mt-5">
        {/* Regular Button */}
        <button
          onClick={() => handleSelect("regular")}
          className={`flex items-center w-full gap-3 border rounded-lg text-white transition-colors duration-300 ${
            selectedType === "regular"
              ? "bg-[#BE3593] text-white"
              : "bg-transparent text-gray-800 hover:bg-purple-100"
          }`}
        >
          <span className="py-3 px-4 bg-[#BE3593] rounded text-white">
            <CiUser size={24} />
          </span>
          Regular
        </button>

        {/* Celebrity Button */}
        <button
          onClick={() => handleSelect("celebrity")}
          className={`flex items-center gap-3 border rounded-lg text-white transition-colors duration-300 ${
            selectedType === "celebrity"
              ? "bg-[#9FCC3B] text-white"
              : "bg-transparent text-gray-800 hover:bg-green-100"
          }`}
        >
          <span className="py-3 px-4 bg-[#9FCC3B] rounded text-white">
            <img
              src="https://www.svgrepo.com/show/13695/star.svg"
              alt="Star"
              width={24}
              height={24}
            />
          </span>
          Celebrity
        </button>
      </div>
    </div>
  );
};

export default AccountTypeSelection;
